import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import ReactApexChart from "react-apexcharts";
import { Urls } from "../../../../Urls";
import axios from "../../../../Axios";
import PlacementEfficiency from "./PlacementEfficiency.js";
import {
  Activity,
  DateFormatter2,
  DateFormatter3,
  currentRequestTimeStamp,
  isMobile,
} from "../../../../Constants";
import Loader from "../../../Loader";
import classes from "./vtdashboard.module.css";
import ReactTooltip from "react-tooltip";
import ProfileModal from "../../../TransporterClientScreen/ProfileModal/ProfileModal";
// import Logo from '../../../../Content/images/logo3.png'
import ReactGA from "react-ga4";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useIndentTracking } from "../../hooks/useIndentTracking";
import PopupModal from "../../../Shared/PopupModal/PopupModal";
import TransitTimeSummary from "./TransitTime.js";

const Vtdashboard = () => {
  const [durationstate, setdurationstate] = useState({
    label: "Today",
    value: "1",
  });
  var durationoptions = [
    // {label:'All', value: '0'},
    { label: "Today", value: "1" },
    { label: "Last 1 week", value: "2" },
    { label: "Last 1 month", value: "3" },
    { label: "Last 3 months", value: "4" },
    // {label:'Custom', value: '4'}
  ];
  const dropdownRef = useRef(null);
  const [allocated, setallocated] = useState(0);
  const [placed, setPlaced] = useState(0);
  const [dispatched, setDispatched] = useState(0);
  const [paymentapproved, setPaymentapproved] = useState(0);
  const [paid, setPaid] = useState(0);
  const [reached, setReached] = useState(0);
  const [unloaded, setUnloaded] = useState(0);
  const [customfiltered, setcustomfiltered] = useState(false);
  const [plantlist, setPlantlist] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState({
    label: "All",
    value: "all",
  });
  const [selectedtransporter, setSelectedtransporter] = useState({
    label: "All",
    value: "all",
  });
  const [transporterList, setTransporterList] = useState([]);
  const [filtersapplied, setfiltersapplied] = useState(false);
  const [showcustomfilters, setShowcustomfilters] = useState(false);
  const [show, setShow] = useState(false);
  const [customfiltersapplied, setCustomfiltersapplied] = useState(false);
  const [noresults, setNoresults] = useState(false);
  const [total, setTotal] = useState(0);
  const [fromdate1, setFromdate1] = useState(new Date());
  const [todate1, settodate1] = useState(new Date());
  const [fulltransporterlist, setFulltransporterlist] = useState([]);
  const [fullplantlist, setFullplantlist] = useState([]);
  const [customselectedtransporter, setcustomselectedtransporter] = useState(
    [],
  );
  const [customselectedplant, setCustomselectedplant] = useState([]);

  const [transittimedata, setTransittimedata] = useState([]);
  const [selectenquirytype, setSelectedenquirytype] = useState("user_view");
  const [useroption, setUseroption] = useState([]);
  const [selectusertype, setselectusertype] = useState("");
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const [selectedEnquiry, setSelectedEnquiry] = useState({
    label: "All",
    value: "all",
  });
  const enquiryOptions = [
    { label: "All", value: "all" },
    { label: "Spot", value: "adhoc" },
    { label: "Indent", value: "indent" },
  ];
  const [selectedFilter, setSelectedFilter] = useState("Today");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { trackIndentEvent } = useIndentTracking();
  useEffect(() => {
    document.title = "LoRRI Indent - Indent Tracking Dashboard";
    ReactGA.send("LoRRI Indent - Indent Tracking Dashboard");
    trackIndentEvent(
      "indent request dashboard",
      "user has visited indent tracking dashboard",
    );
    updatedata();
  }, [durationstate, selectedPlant, selectedtransporter, selectedEnquiry]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (value) => {
    setSelectedFilter(value);
    setDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };
  const toggleDropdown = (e) => {
    if (!dropdownOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setDropdownPos({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
    }
    setDropdownOpen(!dropdownOpen);
  };

  function convertDateFormat(dateInput) {
    // Check if the input is already in YYYY-MM-DD format
    const regex = /^\d{4}-\d{2}-\d{2}$/;

    if (regex.test(dateInput)) {
      // If it's already in the correct format, return it
      return dateInput;
    } else {
      // Otherwise, convert from ISO format to YYYY-MM-DD
      const date = new Date(dateInput);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    }
  }

  const handleCustomDate = ({ date, type = "" }) => {
    setSelectedFilter("");
    if (type === "toDate") {
      settodate1(date.toISOString());
    } else if (type === "fromDate") {
      setFromdate1(date.toISOString());
    }
  };
  const updatedata = () => {
    var Url, Url2;
    if (durationstate.value === "1") {
      Url = `${Urls.indentdashboard}?field=vehicle_track_dashboard&window=today`;
      Url2 = `${Urls.indentdashboard}?field=transit_time_dashboard&window=today`;
      setfiltersapplied(true);
      if (
        selectedtransporter.value !== "all" &&
        selectedPlant.value !== "all"
      ) {
        getData(
          Url,
          {
            today: DateFormatter2(Date()),
            transporter_list: [selectedtransporter.value],
            plant: [selectedPlant.value],
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else if (
        selectedPlant.value === "all" &&
        selectedtransporter.value !== "all"
      ) {
        getData(
          Url,
          {
            today: DateFormatter2(Date()),
            transporter_list: [selectedtransporter.value],
            plant: [selectedPlant.value],
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else if (
        selectedPlant.value !== "all" &&
        selectedtransporter.value === "all"
      ) {
        getData(
          Url,
          {
            today: DateFormatter2(Date()),
            plant: [selectedPlant.value],
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            transporter_list: [selectedtransporter.value],
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else {
        getData(
          Url,
          {
            today: DateFormatter2(Date()),
            transporter_list: [selectedtransporter.value],
            plant: [selectedPlant.value],
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            from: selectedEnquiry.value,
          },
          Url2,
        );
      }
    } else if (durationstate.value === "2") {
      setfiltersapplied(true);
      Url = `${Urls.indentdashboard}?field=vehicle_track_dashboard&window=week`;
      Url2 = `${Urls.indentdashboard}?field=transit_time_dashboard&window=week`;
      var lastWeek = getLastWeek();
      var lastWeekMonth = ("0" + (lastWeek.getMonth() + 1)).slice(-2);
      var lastWeekDay = ("0" + lastWeek.getDate()).slice(-2);
      var lastWeekYear = lastWeek.getFullYear();
      var fd =
        lastWeekYear.toString() +
        "-" +
        lastWeekMonth.toString() +
        "-" +
        lastWeekDay.toString();
      var mindate = new Date();
      var day = ("0" + mindate.getDate()).slice(-2);
      var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
      var year = mindate.getFullYear();
      var td =
        year.toString() + "-" + month.toString() + "-" + day.toString() + "";
      if (
        selectedtransporter.value !== "all" &&
        selectedPlant.value !== "all"
      ) {
        getData(
          Url,
          {
            from_date: fd,
            to_date: td,
            transporter_list: [selectedtransporter.value],
            plant: [selectedPlant.value],
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else if (
        selectedPlant.value === "all" &&
        selectedtransporter.value !== "all"
      ) {
        getData(
          Url,
          {
            from_date: fd,
            to_date: td,
            transporter_list: [selectedtransporter.value],
            plant: [selectedPlant.value],
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else if (
        selectedPlant.value !== "all" &&
        selectedtransporter.value === "all"
      ) {
        getData(
          Url,
          {
            from_date: fd,
            to_date: td,
            plant: [selectedPlant.value],
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            transporter_list: [selectedtransporter.value],
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else {
        getData(
          Url,
          {
            from_date: fd,
            to_date: td,
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            plant: [selectedPlant.value],
            transporter_list: [selectedtransporter.value],
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            from: selectedEnquiry.value,
          },
          Url2,
        );
      }
    } else if (durationstate.value === "3") {
      setfiltersapplied(true);
      Url = `${Urls.indentdashboard}?field=vehicle_track_dashboard&window=month`;
      Url2 = `${Urls.indentdashboard}?field=transit_time_dashboard&window=month`;
      const mindate = new Date();
      let day = ("0" + mindate.getDate()).slice(-2);
      let month = ("0" + (mindate.getMonth() + 1)).slice(-2);
      let month1 = ("0" + mindate.getMonth()).slice(-2);
      let year = mindate.getFullYear();

      const td =
        year.toString() + "-" + month.toString() + "-" + day.toString();
      if (mindate.getMonth() === 0) {
        // If current month is January
        month1 = "12"; // December
        year -= 1; // Previous year
      }
      const fd =
        year.toString() + "-" + month1.toString() + "-" + day.toString();
      if (
        selectedtransporter.value !== "all" &&
        selectedPlant.value !== "all"
      ) {
        getData(
          Url,
          {
            from_date: fd,
            to_date: td,
            transporter_list: [selectedtransporter.value],
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            plant: [selectedPlant.value],
            view: selectenquirytype,
            email: `${localStorage.getItem("useremail")}`,
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else if (
        selectedPlant.value === "all" &&
        selectedtransporter.value !== "all"
      ) {
        getData(
          Url,
          {
            from_date: fd,
            to_date: td,
            transporter_list: [selectedtransporter.value],
            view: selectenquirytype,
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            plant: [selectedPlant.value],
            email: `${localStorage.getItem("useremail")}`,
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else if (
        selectedPlant.value !== "all" &&
        selectedtransporter.value === "all"
      ) {
        getData(
          Url,
          {
            from_date: fd,
            to_date: td,
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            plant: [selectedPlant.value],
            view: selectenquirytype,
            transporter_list: [selectedtransporter.value],
            email: `${localStorage.getItem("useremail")}`,
            from: selectedEnquiry.value,
          },
          Url2,
        );
      } else {
        getData(
          Url,
          {
            from_date: fd,
            to_date: td,
            plant: [selectedPlant.value],
            email_list:
              selectenquirytype === "company_view" ? [selectusertype] : [""],
            view: selectenquirytype,
            from: selectedEnquiry.value,
            transporter_list: [selectedtransporter.value],
            email: `${localStorage.getItem("useremail")}`,
          },
          Url2,
        );
      }
    } else if (durationstate.value === "4") {
      Activity([
        {
          screen: "Indents",
          module: "Indent Tracking Dashboard",
          user_activity: `Custom Filter submit button`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);

      // Get today's date
      const mindate = new Date();
      const td = `${mindate.getFullYear()}-${("0" + (mindate.getMonth() + 1)).slice(-2)}-${("0" + mindate.getDate()).slice(-2)}`;

      // Calculate the date 3 months ago
      const startdate = new Date();
      startdate.setMonth(startdate.getMonth() - 3);
      const fd = `${startdate.getFullYear()}-${("0" + (startdate.getMonth() + 1)).slice(-2)}-${("0" + startdate.getDate()).slice(-2)}`;
      if (customfiltersapplied === false) {
        setFromdate1(fd);
        settodate1(td);
      }

      const params = {
        from_date: fd,
        to_date: td,
        view: selectenquirytype,
        email: localStorage.getItem("useremail"),
      };

      let Url = `${Urls.indentdashboard}?field=vehicle_track_dashboard&window=custom`;
      let Url2 = `${Urls.indentdashboard}?field=transit_time_dashboard&window=custom`;
      getData(
        Url,
        {
          from_date: DateFormatter3(fromdate1),
          to_date: DateFormatter3(todate1),
          email_list:
            selectenquirytype === "company_view" ? [selectusertype] : [""],
          transporter_list: [selectedtransporter.value],
          plant: [selectedPlant.value],
          view: selectenquirytype,
          email: `${localStorage.getItem("useremail")}`,
          from: selectedEnquiry.value,
        },
        Url2,
      );
    }
  };
  const getData = (Url, payload, Url2, whole) => {
    setNoresults(false);
    setShow(true);
    setallocated(0);
    setPlaced(0);
    setDispatched(0);
    // setIntransit(0)
    setPaymentapproved(0);
    setPaid(0);
    setReached(0);
    setUnloaded(0);
    axios
      .post(Url, payload)
      .then((res) => {
        if (
          res.data &&
          res.data.transporter_list &&
          res.data.transporter_list.length > 0
        ) {
          setUseroption(res.data.user_list);
          var plant_list = [{ label: "All", value: "all" }];
          // var plant_list = []
          res.data.plant_list.map((v) =>
            plant_list.push({ label: v, value: v }),
          );
          setPlantlist(plant_list);
          setTotal(res.data.total_indents_allocated);
          var tr_list = [{ label: "All", value: "all" }];
          res.data.transporter_list.map((v) =>
            tr_list.push({
              label: v.transporter_name,
              value: v.transporter_id,
              sla: v.sla,
            }),
          );
          setTransporterList(tr_list);
          // var tr_list = []
          if (whole) {
            var tr_list1 = [];
            res.data.transporter_list.map((v) =>
              tr_list1.push({
                label: v.transporter_name,
                value: v.transporter_id,
                sla: v.sla,
              }),
            );
            setFulltransporterlist(tr_list1);
            var plant_list1 = [];
            res.data.plant_list.map((v) =>
              plant_list1.push({ label: v, value: v }),
            );
            setFullplantlist(plant_list1);
          }
          if (res?.data?.status_agg) {
            // console.log(res.data.status_agg)
            return (
              res.data?.status_agg?.length > 0 &&
              res.data.status_agg.map((status) => {
                if (status?.value === "yet to be placed") {
                  setallocated(status?.size);
                }
                if (status?.value === "placed") {
                  setPlaced(status?.size);
                }
                if (status?.value === "dispatched") {
                  setDispatched(status?.size);
                }
                // if(status.value === 'in transit'){
                //     setIntransit(status.size)
                // }
                if (status.value === "paymentapproved") {
                  setPaymentapproved(status.size);
                }
                if (status.value === "paid") {
                  setPaid(status.size);
                }
                if (status?.value === "reached") {
                  setReached(status.size);
                }
                if (status?.value === "unloaded") {
                  setUnloaded(status.size);
                }
                return null;
              })
            );
          }
          // setShow(false)
        } else {
          setShow(false);
          setTransporterList([]);
          setPlantlist([]);
          setFullplantlist([]);
          setNoresults(true);
        }
      })
      .catch((e) => {
        setShow(false);
        console.log(e);
      });
    setShow(true);
    axios
      .post(Url2, payload)
      .then((res) => {
        setTransittimedata(res.data.transits);
        setShow(false);
      })
      .catch((e) => {
        console.log(e);
        setShow(false);
      });
  };

  function getLastWeek() {
    var today = new Date();
    var lastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7,
    );
    return lastWeek;
  }
  const changeHandler = (e, v, filterValue) => {
    if (v === "transporter") {
      setSelectedtransporter(e);
      Activity([
        {
          screen: "Indents",
          module: "Indent Tracking Dashboard",
          user_activity: `Filter for transporter: ${e.label}`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);
      trackIndentEvent(
        "indent tracking dashboard",
        `user has clicked on select transporter filter`,
        `Filtered by : ${e.label}`,
      );
    }
    if (v === "plant") {
      setSelectedPlant(e);
      Activity([
        {
          screen: "Indents",
          module: "Indent Tracking Dashboard",
          user_activity: `Filter for plant: ${e.value}`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);
      trackIndentEvent(
        "indent tracking dashboard",
        `user has clicked on select plant filter`,
        `Filtered by : ${e.label}`,
      );
    }
    if (v === "enquiry") {
      setSelectedEnquiry(e);
      Activity([
        {
          screen: "Indents",
          module: "Indent Tracking Dashboard",
          user_activity: `Filter for enquiry: ${e.value}`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);
      trackIndentEvent(
        "indent tracking dashboard",
        `user has clicked on select enquiry type filter`,
        `Filtered by : ${e.label}`,
      );
    }
    if (v === "duration") {
      Activity([
        {
          screen: "Indents",
          module: "Indent Tracking Dashboard",
          user_activity: `Filter for duration: ${e.label}`,
          timestamp: currentRequestTimeStamp(),
        },
      ]);
      if (e === 1) {
        setdurationstate({ label: "Today", value: "1" });
      } else if (e === 2) {
        setdurationstate({ label: "Last 1 week", value: "2" });
        var lastWeek = getLastWeek();
        var lastWeekMonth = ("0" + (lastWeek.getMonth() + 1)).slice(-2);
        var lastWeekDay = ("0" + lastWeek.getDate()).slice(-2);
        var lastWeekYear = lastWeek.getFullYear();
        const fd =
          lastWeekYear.toString() +
          "-" +
          lastWeekMonth.toString() +
          "-" +
          lastWeekDay.toString();
        var mindate = new Date();
        var day = ("0" + mindate.getDate()).slice(-2);
        var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
        var year = mindate.getFullYear();
        const td =
          year.toString() + "-" + month.toString() + "-" + day.toString() + "";
        if (customfiltersapplied === false) {
          setFromdate1(fd);
          settodate1(td);
        }
      } else if (e === 3) {
        setdurationstate({ label: "Last 1 month", value: "3" });
        const mindate = new Date();

        let day = ("0" + mindate.getDate()).slice(-2);
        let month = ("0" + (mindate.getMonth() + 1)).slice(-2);
        let month1 = ("0" + mindate.getMonth()).slice(-2); // Should keep the current month, not adjust for previous month yet
        let year = mindate.getFullYear();

        const td =
          year.toString() + "-" + month.toString() + "-" + day.toString();
        if (mindate.getMonth() === 0) {
          // If current month is January
          month1 = "12"; // December
          year -= 1; // Previous year
        }

        const fd =
          year.toString() + "-" + month1.toString() + "-" + day.toString();

        if (customfiltersapplied === false) {
          setFromdate1(fd);
          settodate1(td);
        }
      }
      setSelectedFilter(filterValue);
      setCustomfiltersapplied(false);
      setDropdownOpen(false);

      trackIndentEvent(
        "indent tracking dashboard",
        `user has clicked on select duration filter`,
        `Filtered by : ${e.label}`,
      );
    }
  };

  var series = [
    {
      name: "No of Indents",
      data: [
        allocated,
        placed,
        dispatched,
        reached,
        unloaded,
        paymentapproved,
        paid,
      ],
    },
  ];
  var series1 = [
    {
      name: "No of Indents",
      data: [30, 20, 10, 20, 10],
    },
  ];
  var options = {
    chart: {
      toolbar: {
        show: false,
        tools: {
          download: true,
        },
      },
    },
    // dataLabels:{
    //     enabled: false
    // },
    xaxis: {
      categories: [
        "Yet to be placed",
        "Placed",
        "Dispatched",
        "Reached",
        "Unloaded",
        "Payment Approved",
        "Paid",
      ],
    },
    yaxis: {},
    stroke: {
      width: 1,
    },
    plotOptions: {
      distributed: true,
    },
    tooltip: {
      // enabled: false,
      y: {
        formatter: (val) => val,
      },
    },
    fill: {
      opacity: 0.8,
    },
    legend: {
      position: "right",
    },
  };

  const DeliveryBar = ({
    early = 0,
    ontime = 0,
    delayed = 0,
    faulty = 0,
    index,
  }) => {
    var tot = early + ontime + delayed + faulty;
    var ep = ((early / tot) * 100).toFixed(0);
    var earlyperc = Math.abs(ep);
    var op = ((ontime / tot) * 100).toFixed(0);
    var ontimeperc = Math.abs(op);
    var dp = ((delayed / tot) * 100).toFixed(0);
    var delayedperc = Math.abs(dp);
    var faultyp = ((faulty / tot) * 100).toFixed(0);
    var faultyperc = Math.abs(faultyp);
    return (
      <>
        <div style={{ display: "flex" }}>
          <ReactTooltip
            id={`early${index}`}
            place="top"
            effect="float"
            backgroundColor="#393185 !important"
          >
            <div>Total Early Deliveries: {early}</div>
          </ReactTooltip>
          <ReactTooltip
            id={`ontime${index}`}
            place="top"
            effect="float"
            backgroundColor="#393185 !important"
          >
            <div>Total On Time Deliveries: {ontime}</div>
          </ReactTooltip>
          <ReactTooltip
            id={`delayed${index}`}
            place="top"
            effect="float"
            backgroundColor="#393185 !important"
          >
            <div>Total Delayed Deliveries: {delayed}</div>
          </ReactTooltip>
          <ReactTooltip
            id={`faulty${index}`}
            place="top"
            effect="float"
            backgroundColor="#393185 !important"
          >
            <div>Transit Time Not Available: {faulty}</div>
          </ReactTooltip>
          {earlyperc > 0 ? (
            <div
              data-tip
              data-for={`early${index}`}
              id={`early${index}`}
              style={{
                width: `${earlyperc}%`,
                fontSize: "13px",
                color: "rgba(44, 160, 44)",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "10px",
                  background: "rgba(44, 160, 44)",
                  border: "3px solid rgba(44, 160, 44)",
                  borderTopRightRadius:
                    delayedperc > 0 || ontimeperc > 0 || faultyperc > 0
                      ? "0"
                      : "5px",
                  borderBottomRightRadius:
                    delayedperc > 0 || ontimeperc > 0 || faultyperc > 0
                      ? "0"
                      : "5px",
                  borderTopLeftRadius: "5px",
                  borderBottomLeftRadius: "5px",
                }}
              ></div>
              <span>{earlyperc}%</span>
            </div>
          ) : null}
          {ontimeperc > 0 ? (
            <div
              data-tip
              data-for={`ontime${index}`}
              id={`ontime${index}`}
              style={{
                width: `${ontimeperc}%`,
                fontSize: "13px",
                color: "orange",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "10px",
                  background: "orange",
                  border: "3px solid orange",
                  borderTopRightRadius:
                    delayedperc > 0 || faultyperc > 0 ? "0" : "5px",
                  borderBottomRightRadius:
                    delayedperc > 0 || faultyperc > 0 ? "0" : "5px",
                  borderTopLeftRadius: earlyperc > 0 ? "0" : "5px",
                  borderBottomLeftRadius: earlyperc > 0 ? "0" : "5px",
                }}
              ></div>
              <span>{ontimeperc}%</span>
            </div>
          ) : null}
          {delayedperc > 0 ? (
            <div
              data-tip
              data-for={`delayed${index}`}
              id={`delayed${index}`}
              style={{
                width: `${delayedperc}%`,
                fontSize: "13px",
                color: "rgba(214, 39, 40)",
              }}
            >
              <div
                style={{
                  width: "100%",
                  background: "rgba(214, 39, 40)",
                  height: "10px",
                  border: "3px solid rgba(214, 39, 40)",
                  borderTopRightRadius: faultyperc > 0 ? "0" : "5px",
                  borderBottomRightRadius: faultyperc > 0 ? "0" : "5px",
                  borderTopLeftRadius:
                    ontimeperc > 0 || earlyperc > 0 ? "0" : "5px",
                  borderBottomLeftRadius:
                    ontimeperc > 0 || earlyperc > 0 ? "0" : "5px",
                }}
              ></div>
              <span>{delayedperc}%</span>
            </div>
          ) : null}
          {faultyperc > 0 ? (
            <div
              data-tip
              data-for={`faulty${index}`}
              id={`faulty${index}`}
              style={{
                width: `${faultyperc}%`,
                fontSize: "13px",
                color: "#727271",
              }}
            >
              <div
                style={{
                  width: "100%",
                  background: "#727271",
                  height: "10px",
                  border: "3px solid #727271",
                  borderTopRightRadius: "5px",
                  borderBottomRightRadius: "5px",
                  borderTopLeftRadius:
                    earlyperc > 0 || ontimeperc > 0 || delayedperc > 0
                      ? "0"
                      : "5px",
                  borderBottomLeftRadius:
                    earlyperc > 0 || ontimeperc > 0 || delayedperc > 0
                      ? "0"
                      : "5px",
                }}
              ></div>
              <span>{faultyperc}%</span>
            </div>
          ) : null}
        </div>
      </>
    );
  };
  const Unavailable = ({ index }) => {
    return (
      <div>
        <ReactTooltip
          id={`unv${index}`}
          place="top"
          effect="float"
          backgroundColor="#393185 !important"
        >
          Currently Unavailable
        </ReactTooltip>
        <div data-tip data-for={`unv${index}`} id={`unv${index}`}>
          --
        </div>
      </div>
    );
  };

  const handleChangeIndenttype = (e) => {
    Activity([
      {
        screen: "Indent Tracking Dashboard",
        module: "Indent Dashboard",
        user_activity: `View Dashboard for ${e.target.value}`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    trackIndentEvent(
      "indent tracking dashboard",
      `user has clicked on enquiry type (my/company indents) filter`,
      `Filtered by: ${e.target.value}`,
    );

    setSelectedenquirytype(e.target.value);
    setShow(true);

    let Url = `${Urls.indentdashboard}?field=vehicle_track_dashboard&window=custom`;
    let Url2 = `${Urls.indentdashboard}?field=transit_time_dashboard&window=custom`;

    getData(
      Url,
      {
        from_date: DateFormatter3(fromdate1),
        to_date: DateFormatter3(todate1),
        email_list:
          selectenquirytype === "company_view" ? [selectusertype] : [""],
        transporter_list: [selectedtransporter.value],
        plant: [selectedPlant.value],
        view: e.target.value,
        email: `${localStorage.getItem("useremail")}`,
        from: selectedEnquiry.value,
      },
      Url2,
    );
  };

  const handleChangeUsertype = (e) => {
    setselectusertype(e.target.value);
    Activity([
      {
        screen: "Indent Tracking Dashboard",
        module: "Indent Dashboard",
        user_activity: `View Dashboard for ${e.target.value}`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    trackIndentEvent(
      "indent tracking dashboard",
      `user has clicked on select user filter`,
      `Filtered by: ${e.target.value}`,
    );

    setSelectedenquirytype("company_view");
    setShow(true);

    let Url = `${Urls.indentdashboard}?field=vehicle_track_dashboard&window=custom`;
    let Url2 = `${Urls.indentdashboard}?field=transit_time_dashboard&window=custom`;

    getData(
      Url,
      {
        from_date: DateFormatter3(fromdate1),
        to_date: DateFormatter3(todate1),
        email_list:
          selectenquirytype === "company_view" ? [e.target.value] : [""],
        transporter_list: [selectedtransporter.value],
        plant: [selectedPlant.value],
        view: selectenquirytype,
        email: `${localStorage.getItem("useremail")}`,
        from: selectedEnquiry.value,
      },
      Url2,
    );
  };
  const submitHandler = () => {
    // Ensure to convert fromDate and toDate back to Date objects
    const parsedFromDate = fromdate1 ? new Date(fromdate1) : null;
    const parsedToDate = todate1 ? new Date(todate1) : null;
    setdurationstate({ label: "4", value: "4" });
    // Check if both dates are set
    if (parsedFromDate && parsedToDate) {
      const diffInMonths =
        (parsedToDate.getFullYear() - parsedFromDate.getFullYear()) * 12 +
        (parsedToDate.getMonth() - parsedFromDate.getMonth());

      // Show error if the difference is greater than 3 months
      if (diffInMonths > 3) {
        toast.error("The date range cannot exceed 3 months.");
        return; // Prevent further execution
      }
    } else {
      toast.error("Please select both from and to dates.");
      return; // Prevent further execution
    }

    Activity([
      {
        screen: "Indents",
        module: "Indent Request Dashboard",
        user_activity: `Custom Filter Submit Button Clicked`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    setCustomfiltersapplied(true);
    setShow(true);
  };

  return (
    <div className={`${classes["newcontainer"]}`}>
      <Loader show={show} />
      <>
        <div
          className={isMobile() ? classes["mobileFilterRow"] : "row d-flex justify-content-end"}
          style={{
            marginTop: isMobile() ? "-2%" : "-7.5%",
            maxWidth: isMobile() ? "100%" : "87%",
            marginLeft: isMobile() ? "0" : "380px",
            gap: "12px",
            display: "flex",
            flexWrap: isMobile() ? "nowrap" : "wrap",
            overflowX: isMobile() ? "auto" : "visible",
            WebkitOverflowScrolling: "touch",
            minWidth: isMobile() ? 0 : undefined,
            boxSizing: "border-box",
          }}
        >
          <div className={``} style={{ width: isMobile() ? "150px" : "13%", flexShrink: isMobile() ? 0 : undefined }}>
            Select type
            <Select
              options={[
                { label: "My Indents", value: "user_view" },
                { label: "Company Indents", value: "company_view" },
              ]}
              value={{
                label: selectenquirytype === "user_view" ? "My Indents" : "Company Indents",
                value: selectenquirytype,
              }}
              onChange={(e) => handleChangeIndenttype({ target: { value: e.value } })}
              className="Truck_type_select"
              classNamePrefix="Truck_Prefix"
              menuPortalTarget={document.body}
              menuPlacement="bottom"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              isSearchable={false}
            />
          </div>
          {selectenquirytype === "company_view" ? (
            <div className={``} style={{ width: isMobile() ? "150px" : "13%", flexShrink: isMobile() ? 0 : undefined }}>
              Select User
              <div style={{ width: "100%" }}>
                <select
                  className={`form-control`}
                  onChange={(e) => handleChangeUsertype(e)}
                >
                  <option disabled selected>
                    Select User
                  </option>
                  {useroption && useroption.length > 0
                    ? useroption.map((item) => {
                      return (
                        <>
                          <option value={item}>{item}</option>
                        </>
                      );
                    })
                    : null}
                </select>
              </div>
            </div>
          ) : null}
          <div className={``} style={{ width: isMobile() ? "150px" : "13%", flexShrink: isMobile() ? 0 : undefined }}>
            Select Transporter
            <Select
              options={transporterList}
              value={selectedtransporter}
              isDisabled={customfiltersapplied}
              onChange={(e) => changeHandler(e, "transporter")}
              className="Truck_type_select"
              classNamePrefix="Truck_Prefix"
              menuPortalTarget={document.body}
              menuPlacement="bottom"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className={``} style={{ width: isMobile() ? "150px" : "13%", flexShrink: isMobile() ? 0 : undefined }}>
            Select Plant
            <Select
              options={plantlist}
              value={selectedPlant}
              isDisabled={customfiltersapplied}
              onChange={(e) => changeHandler(e, "plant")}
              className="Truck_type_select"
              classNamePrefix="Truck_Prefix"
              menuPortalTarget={document.body}
              menuPlacement="bottom"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
          <div className={``} style={{ width: isMobile() ? "150px" : "13%", flexShrink: isMobile() ? 0 : undefined }}>
            Enquiry Type
            <Select
              options={enquiryOptions}
              value={selectedEnquiry}
              isDisabled={customfiltersapplied}
              onChange={(e) => changeHandler(e, "enquiry")}
              className="Truck_type_select"
              classNamePrefix="Truck_Prefix"
              menuPortalTarget={document.body}
              menuPlacement="bottom"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
          <div className="dropdown" ref={dropdownRef}>
            <button
              className={`btn btn-secondary dropdown-toggle ${classes["dropDown-btn"]}`}
              type="button"
              id="dropdownMenuButton"
              // data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={(e) => toggleDropdown(e)}
            >
              {selectedFilter || "Filters"}
            </button>
            <div
              className={`dropdown-menu ${dropdownOpen ? "show" : ""}`}
              aria-labelledby="dropdownMenuButton"
              style={
                isMobile() && dropdownOpen
                  ? {
                    position: 'fixed',
                    top: dropdownPos.top,
                    left: dropdownPos.left,
                    zIndex: 2000,
                    maxHeight: '70vh',
                    overflowY: 'auto',
                  }
                  : undefined
              }
            >
              {["Today", "Last 7 Days", "Last 30 Days"].map((filter, index) => (
                <li
                  style={{ userSelect: "none", cursor: "pointer" }}
                  key={filter}
                  className={`dropdown-item ${selectedFilter === filter ? "active" : ""
                    }`}
                  onClick={(e) => changeHandler(index + 1, "duration", filter)}
                >
                  {filter}
                </li>
              ))}
              <div className="dropdown-divider"></div>
              <div
                className={`dropdown-item drop${classes["custom-date-dropdown"]}`}
              >
                <div className="mb-2">Custom Date</div>
                <div className="">
                  <div className="">
                    <div>From</div>
                    <DatePicker
                      maxDate={new Date(todate1)}
                      selected={new Date(fromdate1)}
                      onChange={(date) =>
                        handleCustomDate({ date: date, type: "fromDate" })
                      }
                      dateFormat="dd/MM/yyyy"
                      popperModifiers={
                        isMobile()
                          ? undefined
                          : [
                            {
                              name: "offset",
                              options: {
                                offset: [5, 10],
                              },
                            },
                            {
                              name: "preventOverflow",
                              options: {
                                rootBoundary: "viewport",
                                tether: false,
                                altAxis: true,
                              },
                            },
                          ]
                      }
                    />
                  </div>
                  <div className="">
                    <div>To</div>
                    <DatePicker
                      minDate={new Date(fromdate1)}
                      selected={new Date(todate1)}
                      dateFormat="dd/MM/yyyy"
                      onChange={(date) =>
                        handleCustomDate({ date: date, type: "toDate" })
                      }
                      popperModifiers={
                        isMobile()
                          ? undefined
                          : [
                            {
                              name: "offset",
                              options: {
                                offset: [5, 10],
                              },
                            },
                            {
                              name: "preventOverflow",
                              options: {
                                rootBoundary: "viewport",
                                tether: false,
                                altAxis: true,
                              },
                            },
                          ]
                      }
                    />
                  </div>
                  <button
                    className={`btn ${classes["apply-filter-btn"]}`}
                    onClick={() => submitHandler()}
                  >
                    Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes["my-container"]}>
          <div className={`row`} style={{ marginTop: "2%" }}>
            <div className={`col-md-6`}>
              <div className={classes["chart-container"]}>
                <div className={classes["numb"]}>1. Vehicle Status</div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    padding: "0 0 0 20px",
                  }}
                >
                  Total Number of Indents Allocated: {total ? total : "NA"}
                </div>
                <div style={{ padding: "1% 0 0 0%" }}>
                  <ReactApexChart
                    options={options}
                    height={250}
                    width={"80%"}
                    series={series}
                    type="bar"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className={classes["chart-container"]}
                style={{ height: "49vh" }}
              >
                <div className={classes["numb"]}>2. Placement Efficiency</div>
                <div style={{ marginTop: `${isMobile() ? "0" : "3%"}` }}>
                  <div style={{ maxHeight: "32vh", overflowY: "auto" }}>
                    <table className="table tablehover table-borderless">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            style={{ width: "45%", textAlign: "left" }}
                          >
                            Transporter Name
                          </th>
                          <th
                            scope="col"
                            style={{ width: "35%", textAlign: "center" }}
                          >
                            Placement Efficiency
                            <span style={{ color: "red", fontWeight: "600" }}>
                              *
                            </span>
                          </th>
                          <th scope="col" style={{ textAlign: "center" }}>
                            Details
                          </th>
                        </tr>
                        {/* <th scope="col">Transit TIme Adherence</th> */}
                      </thead>
                      <tbody>
                        {transporterList && transporterList.length > 0 ? (
                          transporterList.map((transporter, index) => {
                            if (transporter.value !== "all") {
                              return (
                                <tr key={`transporter${index}`}>
                                  <td style={{ textAlign: "left" }}>
                                    <ProfileModal
                                      buttonClass={`btn-link ${classes["transporterName"]}`}
                                      transporter_id={transporter.value}
                                      transporter_name={transporter.label}
                                      screenName={"Indents Request"}
                                      moduleName={"LoRRI Indents"}
                                    />
                                  </td>
                                  <td>{transporter.sla}%</td>

                                  <td>
                                    <PopupModal
                                      buttonLabel={<>Click Here</>}
                                      content={
                                        <PlacementEfficiency
                                          transittimedata={transittimedata}
                                          selectedTransporterId={
                                            transporter.value
                                          }
                                        />
                                      }
                                      buttonClass={`btn px-8 mr-2 btn-link`}
                                      title={`Placement Efficiency Summary`}
                                      size={"2xl"}
                                      screenName={"Indent Tracking Dashboard"}
                                    ></PopupModal>
                                  </td>
                                </tr>
                              );
                            }
                          })
                        ) : (
                          <>No transporters found</>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <span>
                      <ul>
                        <li>
                          <i>Placement Efficiency</i>
                          <span style={{ color: "red", fontWeight: "600" }}>
                            *
                          </span>{" "}
                          = (No. trucks placed/ No. trucks allocated)*100
                        </li>
                      </ul>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className={classes["transit-container"]}>
              <div className="row">
                <div className="col-md-5">
                  <div className={classes["numb"]}>3. Transit Time Summary</div>
                </div>
                <div
                  className="col-md-7"
                  style={{ textAlign: "right", paddingRight: "3%" }}
                >
                  <div
                    style={{
                      width: isMobile() ? "" : "400px",
                      marginLeft: isMobile() ? "" : "5%",
                    }}
                  >
                    <span style={{ fontWeight: "600" }}>Note:</span>
                    <span style={{ color: "red", fontWeight: "600" }}>*</span>
                    <span>
                      {" "}
                      The average transit time, average delay and status of
                      delivery is only for those indents whose status is
                      unloaded
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ width: "100%", overflowX: "auto" }}>
                <div></div>
                <table className={`table table-stripped table-borderless`}>
                  <thead className="thead-light">
                    <tr>
                      <th style={{ width: "25%", textAlign: "center" }}>
                        Lanes
                      </th>
                      <th style={{ width: "5%", textAlign: "center" }}>
                        View Details
                      </th>
                      <th style={{ width: "5%", textAlign: "center" }}>
                        # Trucks Allocated
                      </th>
                      <th style={{ width: "5%", textAlign: "center" }}>
                        # Trucks Unloaded
                      </th>
                      <th style={{ width: "12.5%", textAlign: "center" }}>
                        <span>Contracted Transit Time</span>
                        <br />
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          (In Days)
                        </span>{" "}
                      </th>
                      <th style={{ width: "12.5%", textAlign: "center" }}>
                        <span>Actual (Avg) Transit Time</span>
                        <br />
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          (In Days)
                        </span>
                      </th>
                      <th style={{ width: "10%", textAlign: "center" }}>
                        <span>Average Delay</span>
                        <br />
                        <span style={{ fontSize: "12px", fontWeight: "300" }}>
                          (In Days)
                        </span>
                      </th>
                      <th style={{ width: "25%", textAlign: "center" }}>
                        <div>Status of Delivery</div>
                        <div style={{ fontSize: "13px", fontWeight: "300" }}>
                          <span style={{ paddingRight: "5px" }}>
                            <i
                              className="fa fa-circle"
                              style={{
                                color: "rgba(44, 160, 44)",
                                fontSize: "11px",
                              }}
                            />{" "}
                            Early
                          </span>
                          <span style={{ paddingRight: "5px" }}>
                            <i
                              className="fa fa-circle"
                              style={{ color: "orange", fontSize: "11px" }}
                            />{" "}
                            On Time
                          </span>
                          <span style={{ paddingRight: "5px" }}>
                            <i
                              className="fa fa-circle"
                              style={{
                                color: "rgba(214, 39, 40)",
                                fontSize: "11px",
                              }}
                            />{" "}
                            Delayed
                          </span>
                          <br />
                          <span style={{ paddingRight: "5px" }}>
                            <i
                              className="fa fa-circle"
                              style={{ color: "#727271", fontSize: "11px" }}
                            />{" "}
                            Not Available
                            <i
                              data-tip
                              data-for={`information`}
                              style={{ color: "#393186", fontSize: "small" }}
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i>
                            <ReactTooltip
                              id={`information`}
                              className={`${classes["tooltip"]}`}
                              place="bottom"
                              effect="float"
                              backgroundColor="#393185 !important"
                            >
                              <span style={{ textAlign: "left" }}>
                                The user has not updated contracted transit time
                                or the user has not updated the status of
                                vehicle in the timeline
                              </span>
                            </ReactTooltip>
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {transittimedata && transittimedata.length > 0 ? (
                      transittimedata.map((data, index) => (
                        <tr key={`transittimedata${index}`}>
                          <td className={`${classes["verticallycenter"]}`}>
                            <div>
                              <ReactTooltip
                                id={`origin${index}`}
                                place="top"
                                effect="float"
                                backgroundColor="#393185 !important"
                              >
                                <span
                                  style={{ fontSize: "12px", color: "white" }}
                                >
                                  Origin:{" "}
                                  {data.indent_info.origin.location_name}
                                </span>
                                <br />

                                <span
                                  style={{ fontSize: "12px", color: "white" }}
                                >
                                  Destination:{" "}
                                  {data.indent_info.destination.location_name}
                                </span>
                              </ReactTooltip>

                              <>
                                <p
                                  data-tip
                                  data-for={`origin${index}`}
                                  id={`origin${index}`}
                                  className={`${classes["lane-route"]}`}
                                >
                                  <span>
                                    {data.indent_info.origin.location.location}
                                  </span>
                                  <i
                                    className="fa fa-arrow-right"
                                    style={{
                                      fontSize: "12px",
                                      padding: "0 2%",
                                    }}
                                  />
                                  <span>
                                    {
                                      data.indent_info.destination.location
                                        .location
                                    }
                                  </span>{" "}
                                </p>
                                <p className={`${classes["lane-truck"]}`}>
                                  <i className={`fa fa-truck`} />
                                  <span>
                                    {data.indent_info.truck_types[0].label}
                                  </span>
                                </p>
                              </>
                            </div>
                          </td>
                          <td className={`${classes["verticallycenter"]}`}>
                            <div>
                              <ReactTooltip
                                id={`origin${index}`}
                                place="top"
                                effect="float"
                                backgroundColor="#393185 !important"
                              ></ReactTooltip>
                              <PopupModal
                                buttonLabel={<>Click Here</>}
                                content={
                                  <TransitTimeSummary
                                    from_date={convertDateFormat(fromdate1)}
                                    to_date={convertDateFormat(todate1)}
                                    transporter_list={[
                                      selectedtransporter.value,
                                    ]}
                                    email={`${localStorage.getItem("useremail")}`}
                                    email_list={
                                      selectenquirytype === "company_view"
                                        ? [selectusertype]
                                        : [""]
                                    }
                                    route={data.route}
                                    contracted_time={data.contracted_transit}
                                    indent_info={data.indent_info}
                                  />
                                }
                                buttonClass={`btn px-8 mr-2 btn-link`}
                                title={`Transit Time Summary`}
                                size={"2xl"}
                                screenName={"Indent Tracking Dashboard"}
                              ></PopupModal>
                            </div>
                          </td>
                          <td
                            className={`${classes["verticallycenter"]}`}
                            style={{ fontSize: "14px", color: "#393186" }}
                          >
                            {data.total_truck_allocated &&
                              data.total_truck_allocated !== "" &&
                              data.total_truck_allocated !== null &&
                              data.total_truck_allocated !== undefined
                              ? data.total_truck_allocated
                              : "0"}
                          </td>
                          <td
                            className={`${classes["verticallycenter"]}`}
                            style={{ fontSize: "14px", color: "#393186" }}
                          >
                            {data.total_deliveries &&
                              data.total_deliveries !== "" &&
                              data.total_deliveries !== null &&
                              data.total_deliveries !== undefined
                              ? data.total_deliveries
                              : "0"}
                          </td>
                          <td
                            className={`${classes["verticallycenter"]}`}
                            style={{ fontSize: "14px", color: "#393186" }}
                          >
                            {data.contracted_transit &&
                              data.contracted_transit !== "" &&
                              data.contracted_transit !== null &&
                              data.contracted_transit !== undefined ? (
                              data.contracted_transit
                            ) : (
                              <Unavailable index={index} />
                            )}
                          </td>
                          <td
                            className={`${classes["verticallycenter"]}`}
                            style={{ fontSize: "14px", color: "#393186" }}
                          >
                            {data.actual_transit_time_avg &&
                              data.actual_transit_time_avg !== "" &&
                              data.actual_transit_time_avg !== null &&
                              data.actual_transit_time_avg !== undefined ? (
                              data.actual_transit_time_avg
                            ) : (
                              <Unavailable index={index} />
                            )}
                          </td>
                          <td
                            className={`${classes["verticallycenter"]}`}
                            style={{ fontSize: "14px", color: "#393186" }}
                          >
                            {data.avg_delay &&
                              data.avg_delay !== "" &&
                              data.avg_delay !== null &&
                              data.avg_delay !== undefined ? (
                              data.avg_delay
                            ) : (
                              <Unavailable index={index} />
                            )}
                          </td>
                          <td className={`${classes["verticallycenter"]}`}>
                            {(data.early_deliveries &&
                              data.early_deliveries !== 0 &&
                              data.early_deliveries !== null &&
                              data.early_deliveries !== undefined) ||
                              (data.delayed_deliveries &&
                                data.delayed_deliveries !== 0 &&
                                data.delayed_deliveries !== null &&
                                data.delayed_deliveries !== undefined) ||
                              (data.on_time_deliveries &&
                                data.on_time_deliveries !== 0 &&
                                data.on_time_deliveries !== null &&
                                data.on_time_deliveries !== undefined) ||
                              (data.faulty_tracks &&
                                data.faulty_tracks !== 0 &&
                                data.faulty_tracks !== null &&
                                data.faulty_tracks !== undefined) ? (
                              <DeliveryBar
                                early={
                                  data.early_deliveries &&
                                    data.early_deliveries !== 0 &&
                                    data.early_deliveries !== null &&
                                    data.early_deliveries !== undefined
                                    ? data.early_deliveries
                                    : 0
                                }
                                ontime={
                                  data.on_time_deliveries &&
                                    data.on_time_deliveries !== 0 &&
                                    data.on_time_deliveries !== null &&
                                    data.on_time_deliveries !== undefined
                                    ? data.on_time_deliveries
                                    : 0
                                }
                                delayed={
                                  data.delayed_deliveries &&
                                    data.delayed_deliveries !== 0 &&
                                    data.delayed_deliveries !== null &&
                                    data.delayed_deliveries !== undefined
                                    ? data.delayed_deliveries
                                    : 0
                                }
                                faulty={
                                  data.faulty_tracks &&
                                    data.faulty_tracks !== 0 &&
                                    data.faulty_tracks !== null &&
                                    data.faulty_tracks !== undefined
                                    ? data.faulty_tracks
                                    : 0
                                }
                                index={index}
                              />
                            ) : (
                              <Unavailable index={index} />
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">No Data Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Vtdashboard;
